import React from "react";
import "./Button.scss"
const Button = ({ text, isloading, onClick, width, isSecondary = false, isBorder = false }) => {
    return (
        <div className={`VirasatDefault-Button ${isSecondary ? "VirasatDefault-SecButton" : isBorder ? "VirasatDefault-borderButton" : ""}`} onClick={onClick} style={{ width }}>
            {isloading && <div className="loader-btn" />}
            {text}
        </div>
    )
}
export default Button